import React, { useState } from "react";

const CheckoutModal = ({ isOpen, onClose, onOrderCreate, selectedShipping }) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    nombre: "",
    apellido: "",
    telefono: "",
    email: "",
    cp: "",
    provincia: "",
    ciudad: "",
    calle: "",
    altura: "",
    depto: "",
    observacion: ""
  });

  // Verificar si es pickup (solo un paso) o envío (dos pasos)
  const isPickup = selectedShipping === "pickup";
  const totalSteps = isPickup ? 1 : 2;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onOrderCreate({ ...formData });
    onClose();
  };

  if (!isOpen) return null;

  // Progreso en porcentaje para la barra
  const progress = (step / totalSteps) * 100;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4 z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-3xl shadow-2xl">
        <div className="relative mb-8">
          {/* Barra de progreso */}
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div 
              className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-in-out" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          
          {/* Indicadores de pasos */}
          <div className="flex justify-between mt-1">
            <div className="flex flex-col items-center">
              <div className={`w-6 h-6 flex items-center justify-center rounded-full mb-1 ${step >= 1 ? 'bg-blue-600 text-white' : 'bg-gray-300'}`}>
                1
              </div>
              <span className="text-xs font-medium">Información Personal</span>
            </div>
            
            {!isPickup && (
              <div className="flex flex-col items-center">
                <div className={`w-6 h-6 flex items-center justify-center rounded-full mb-1 ${step >= 2 ? 'bg-blue-600 text-white' : 'bg-gray-300'}`}>
                  2
                </div>
                <span className="text-xs font-medium">Dirección de Envío</span>
              </div>
            )}
          </div>
        </div>

        <h2 className="text-2xl font-bold mb-6 text-center">
          {step === 1 ? "Información Personal" : "Dirección de Envío"}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Paso 1: Información Personal */}
          {step === 1 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <label htmlFor="nombre" className="block text-sm font-medium text-gray-700">Nombre</label>
                <input 
                  type="text" 
                  id="nombre"
                  name="nombre" 
                  value={formData.nombre} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                  required 
                />
              </div>
              
              <div className="space-y-2">
                <label htmlFor="apellido" className="block text-sm font-medium text-gray-700">Apellido</label>
                <input 
                  type="text" 
                  id="apellido"
                  name="apellido" 
                  value={formData.apellido} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                  required 
                />
              </div>
              
              <div className="space-y-2">
                <label htmlFor="telefono" className="block text-sm font-medium text-gray-700">Teléfono</label>
                <input 
                  type="text" 
                  id="telefono"
                  name="telefono" 
                  value={formData.telefono} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                  required 
                />
              </div>
              
              <div className="space-y-2 md:col-span-2">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                <input 
                  type="email" 
                  id="email"
                  name="email" 
                  value={formData.email} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                  required 
                />
              </div>
            </div>
          )}
          
          {/* Paso 2: Dirección de Envío (solo si no es pickup) */}
          {step === 2 && !isPickup && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <label htmlFor="cp" className="block text-sm font-medium text-gray-700">Código Postal</label>
                <input 
                  type="text" 
                  id="cp"
                  name="cp" 
                  value={formData.cp} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                  required 
                />
              </div>
              
              <div className="space-y-2">
                <label htmlFor="provincia" className="block text-sm font-medium text-gray-700">Provincia</label>
                <input 
                  type="text" 
                  id="provincia"
                  name="provincia" 
                  value={formData.provincia} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                  required 
                />
              </div>
              
              <div className="space-y-2">
                <label htmlFor="ciudad" className="block text-sm font-medium text-gray-700">Ciudad</label>
                <input 
                  type="text" 
                  id="ciudad"
                  name="ciudad" 
                  value={formData.ciudad} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                  required 
                />
              </div>
              
              <div className="space-y-2">
                <label htmlFor="calle" className="block text-sm font-medium text-gray-700">Calle</label>
                <input 
                  type="text" 
                  id="calle"
                  name="calle" 
                  value={formData.calle} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                  required 
                />
              </div>
              
              <div className="space-y-2">
                <label htmlFor="altura" className="block text-sm font-medium text-gray-700">Altura</label>
                <input 
                  type="text" 
                  id="altura"
                  name="altura" 
                  value={formData.altura} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                  required 
                />
              </div>
              
              <div className="space-y-2">
                <label htmlFor="depto" className="block text-sm font-medium text-gray-700">Departamento</label>
                <input 
                  type="text" 
                  id="depto"
                  name="depto" 
                  value={formData.depto} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                />
              </div>
              
              <div className="space-y-2 md:col-span-2">
                <label htmlFor="observacion" className="block text-sm font-medium text-gray-700">Observaciones</label>
                <textarea 
                  id="observacion"
                  name="observacion" 
                  value={formData.observacion} 
                  onChange={handleChange} 
                  className="border border-gray-300 p-3 rounded-md w-full h-24 resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                ></textarea>
              </div>
            </div>
          )}

          {/* Botones de navegación */}
          <div className="flex justify-between pt-4 border-t">
            <div>
              {step > 1 && (
                <button 
                  type="button" 
                  onClick={prevStep} 
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                >
                  Anterior
                </button>
              )}
            </div>
            
            <div className="flex space-x-3">
              <button 
                type="button" 
                onClick={onClose} 
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              >
                Cancelar
              </button>
              
              {(step < totalSteps) ? (
                <button 
                  type="button" 
                  onClick={nextStep} 
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                >
                  Siguiente
                </button>
              ) : (
                <button 
                  type="submit" 
                  className="px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition"
                >
                  Confirmar
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CheckoutModal;